// libs
import { useState, useEffect } from "react";

// components
import Action from "../../components/Action";

// custom hooks
import useActions from "../../hooks/useActions";
import useToken from "../../hooks/useToken";
import useProducts from "../../hooks/useProducts.jsx";

// utils
import API from "../../utils/api";

// styles
import classes from "./styles.module.css";

export default function Actions() {
  const { actions, setActions } = useActions();
  const { products, fetchProducts } = useProducts();

  const [token] = useToken();
  const [page, setPage] = useState(0);
  const [pages, setPages] = useState(0);

  const prevPage = () => {
    if (page > 0) {
      setPage((prev) => prev - 1);
    }
  };

  const nextPage = () => {
    const isHasNextPage = page < pages;

    if (isHasNextPage) {
      setPage((prev) => prev + 1);
    }
  };

  const getActions = (page) => {
    API.getToken(`/actions/list/${page}`, token).then((d) => {
      if (d?.status === 200) {
        setActions(d.data.actions);
        setPages(d?.data.pages);
      }
    });
  };

  useEffect(() => {
    if (token === null) return;
    getActions(page);
  }, [token, page]);

  useEffect(() => {
    if (token === null || products.length > 0) return;
    fetchProducts(token);
  }, [token]);

  return (
    <div className={classes.root}>
      <div className={classes.actions}>
        {actions.map((action) => (
          <Action key={action.id} data={action} />
        ))}
      </div>
    </div>
  );
}
